import { i18n } from "../../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import {
  replaceWedgeElementStroke,
  replaceWedgeElementFill,
  replaceWedgeOpacity,
  WedgeElement
} from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputColor from '../../InputColor'
import InputText from '../../InputText'

interface Props {
  selectedElement: WedgeElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class WedgeProperties extends Component<CombinedProps> {
  handleInputChange = (name: string, value: string) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    const { id } = selectedElement
    if (name === 'stroke') this.props.replaceWedgeElementStroke(id, value)
    if (name === 'fill')   this.props.replaceWedgeElementFill(id, value)
    if (name === 'opacity') this.props.replaceWedgeOpacity(id, Number(value))
  }

  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'wedge') return
    return (
      <Fragment>
        <Heading
          className="mb-1"
          text={i18n("Wedge")}
          size="small" />        
        <InputText
          type="number"
          name="opacity"
          value={String(selectedElement.opacity)}
          label={i18n("Transparency")}
          onChange={this.handleInputChange} 
          enforceLimits={true} /> 
        <InputColor
          name="stroke"
          value={selectedElement.stroke}
          label="Stroke"
          onChange={this.handleInputChange} />
        <InputColor
          name="fill"
          value={selectedElement.fill}
          label="Fill"
          onChange={this.handleInputChange} />   
      </Fragment>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {}
}

const mapDispatchToProps = {
  replaceWedgeElementStroke,
  replaceWedgeElementFill,
  replaceWedgeOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(WedgeProperties)
